import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const PageLoading = ({ size = 40, color }) => {
  const theme = useTheme();
  const resolvedColor = color ?? theme.palette.primary.main;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={3}
    >
      <CircularProgress size={size} style={{ color: resolvedColor }} data-testid="loading-spinner" />
      <Typography variant="h6" style={{ color: resolvedColor }}>
        You will be redirected shortly...
      </Typography>
    </Box>
  );
};

export default PageLoading;
